
document.addEventListener("DOMContentLoaded", function(){

  // Contact Form
  if(document.getElementById('send-contact-form')){

    let button = document.getElementById('send-contact-form');
    let terms = document.querySelector('.contact-form [name=consent]');
    terms.onchange = function() {
      button.disabled = !this.checked;
    };

    // Get the message parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const messageParam = urlParams.get('message');

    // Populate the textarea with the message parameter
    if (messageParam) {
      const messageTextarea = document.getElementById('message');
      messageTextarea.value = decodeURIComponent(messageParam);
    }

    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();

      document.querySelector("html").classList.remove('site-loaded');
      button.disabled = true;
      button.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let forename = document.querySelector('#contact-form [name=forename]').value;
          let surname = document.querySelector('#contact-form [name=surname]').value;
          let company = document.querySelector('#contact-form [name=company]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=message]').value;
          let subject = document.querySelector('#contact-form [name=subject]').options[document.querySelector('#contact-form [name=subject]').selectedIndex].text;
          let country = document.querySelector('#contact-form [name=country]').options[document.querySelector('#contact-form [name=country]').selectedIndex].text;
          let groupNumber = document.querySelector('#contact-form [name=group]').value;
          let travelDate = document.querySelector('#contact-form [name=date]').value;
          let daysNumber = document.querySelector('#contact-form [name=days]').value;
          let nightsNumber = document.querySelector('#contact-form [name=nights]').value;
          let csrf_token = document.querySelector('#contact-form [name=_token]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'name': forename+' '+surname,
              'forename': forename,
              'surname': surname,
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': `SUBJECT: ${subject} | \n\r COUNTRY: ${country} | \n\r GROUP NUMBER: ${groupNumber} | \n\r TRAVEL DATE: ${travelDate} | \n\r NUMBER OF DAYS: ${daysNumber} | \n\r NUMBER OF NIGHTS: ${nightsNumber} | \n\r ADDITIONAL INFORMATION: ${comments}`,
              '_token': csrf_token,
              'g-recaptcha-response': recaptcha_token
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.querySelector("html").classList.add('site-loaded');
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                  response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button.disabled = false;
              button.innerHTML = 'Submit Enquiry';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-form')[0].classList.add('d-none');
            document.getElementsByClassName('thank-you')[0].classList.remove('d-none');
            document.getElementsByClassName('contact')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.querySelector("html").classList.add('site-loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }

// Subscribe Form
  if(document.getElementById('email-signup')){
    document.getElementById('email-signup').addEventListener("click", function(e) {
      e.preventDefault();

      var recaptcha_token = null;

      if(document.querySelector('input[name=g-recaptcha-response]')){
        recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
      } else {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
          recaptcha_token = token;
        });
      }

      document.getElementById('email-signup').classList.add('preload');
      document.getElementById('email-signup').innerText = 'please wait...';
      document.getElementById('email-signup').disabled = true;

      let url = '/newsletter';
      let email = document.getElementById('newsletter-email').value;
      let name = 'Subscriber';
      let token = document.getElementsByName('_token')[0].value;

      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify({ 'name': name, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
        headers:{
          'Content-Type': 'application/json'
        }}).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        document.getElementById('email-signup').classList.remove('preload');
        document.getElementById('email-signup').innerText = 'Subscribe';
        document.getElementById('email-signup').disabled = false;

        if(data.status!='ok'){
          let errors = '';
          for (var i in data.errors) {
            errors += data.errors[i][0]+'\n';
          }
          if(typeof Swal !== 'undefined'){
            return Swal.fire({
              title: 'Whoops!',
              html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else {
            return alert('There was a problem with your sign up details\n\n'+errors);
          }
        }

        document.getElementsByClassName('newsletter-form')[0].reset();
        // Trigger event tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Newsletter Signup'
        });

        if(typeof Swal !== 'undefined'){
          return Swal.fire({
            title: 'Thank you!',
            text: 'You\'re signed up!',
            icon: 'success',
            confirmButtonText: 'OK'
          });
        } else {
          return alert('Thank you!');
        }

      }).catch(function(err) {
        console.error('Fetch Error -', err);
        document.getElementById('email-signup').classList.remove('preload');
        document.getElementById('email-signup').innerHTML = 'Subscribe';
        document.getElementById('email-signup').disabled = false;
      });
    });
  }

  let filterData;
  if (document.querySelector('.subject-page')){
    filterData = 'country';
  } else if (document.querySelector('.country-page')){
    filterData = 'subject';
  }

  // Dropdown Country Filters
  if (document.querySelector('#dropdown-country-filter')){
    const tripCategory = (cat) => {
      if (cat === 'all') {
        document.querySelectorAll('#available-trips .trip-box').forEach(v => { v.classList.remove('visuallyhidden') })
      } else {
        document.querySelectorAll('#available-trips .trip-box').forEach(v => { v.classList.add('visuallyhidden') })
        document.querySelectorAll(`#available-trips .trip-box[data-${filterData}=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
      }
    }
    document.querySelector('#dropdown-country-filter').addEventListener('change', e => {
      tripCategory(e.target.options[e.target.selectedIndex].value)
    })
  }
  // END Dropdown Country Filters

  // Subject Filters
  if (document.querySelector('#button-filter')){
    const tripCategory = (cat) => {
      if (cat === 'all') {
        document.querySelectorAll('#button-filter a').forEach(v => { v.classList.remove('active') })
        document.querySelector(`#button-filter a[data-category=all]`).classList.add('active')
        document.querySelectorAll('#available-trips .trip-box').forEach(v => { v.classList.remove('visuallyhidden') })
      } else {
        document.querySelectorAll('#button-filter a').forEach(v => { v.classList.remove('active') })
        document.querySelector(`#button-filter a[data-category=${cat}]`).classList.add('active')
        document.querySelectorAll('#available-trips .trip-box').forEach(v => { v.classList.add('visuallyhidden') })
        document.querySelectorAll(`#available-trips .trip-box[data-${filterData}=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
      }
    }
    document.querySelectorAll('#button-filter a').forEach(v => {
      v.addEventListener('click', e => {
        tripCategory(e.target.dataset.category)
      })
    })

    document.querySelector('#dropdown-subject-filter').addEventListener('change', e => {
      tripCategory(e.target.options[e.target.selectedIndex].value)
    })
  }
  // END Subject Filters

  // GLIDE JS

  // Trip Page Gallery
  const tripGallery = document.querySelector('#trip-page-gallery-track');
  if (tripGallery) {
    let tripGlide = new Glide(tripGallery, {
      type: 'carousel',
      perView: 3,
      gap: 30,
      autoplay: 10000,
      focusAt: 'center',
      breakpoints: {
        2000: {
          perView: 1,
          gap: 20,
          peek: {
            before: 300,
            after: 300
          }
        },
        1200: {
          perView: 1,
          gap: 15,
          peek: {
            before: 150,
            after: 150
          }
        },
        768: {
          perView: 1,
          gap: 10,
          peek: {
            before: 50,
            after: 50
          }
        }
      }
    })

    tripGlide.mount()
  }

  // Excursions Gallery
  const excursionsGallery = document.querySelector('#excursions-gallery-track');
  if (excursionsGallery) {
    let excGlide = new Glide(excursionsGallery, {
      type: 'carousel',
      perView: 3,
      gap: 30,
      dragThreshold: false,
      breakpoints: {
        2000: {
          perView: 3,
          gap: 20,
          dragThreshold: false,
        },
        1200: {
          perView: 2,
          gap: 15,
          dragThreshold: false,
        },
        560: {
          perView: 1,
          gap: 10,
          dragThreshold: false,
        }
      }
    })

    excGlide.mount()
  }

  // Testimonials Track
  const testimonials = document.querySelector('#testimonials-track');
  if (testimonials) {
    let testimonialsGlide = new Glide(testimonials, {
      type: 'carousel',
      perView: 2,
      gap: 15,
      breakpoints: {
        768: {
          perView: 1,
          gap: 10
        }
      }
    })

    testimonialsGlide.mount()
  }

  // Trip Page Gallery
  const popularTrips = document.querySelector('#popular-trips-track');
  if (popularTrips) {
    let popularTripGlide = new Glide(popularTrips, {
      type: 'carousel',
      perView: 3,
      gap: 30,
      breakpoints: {
        2000: {
          perView: 3,
          gap: 20
        },
        1200: {
          perView: 2,
          gap: 15
        },
        768: {
          perView: 1,
          gap: 10
        }
      }
    })

    popularTripGlide.mount()
  }

  // END GLIDE JS

  // Load Trips
  const subjectSelect = document.querySelector('#subject');
  const countrySelect = document.querySelector('#country');

  if(subjectSelect && countrySelect){

    const subjectOptions = subjectSelect.querySelectorAll('option');
    const countryOptions = countrySelect.querySelectorAll('option');

    countrySelect.addEventListener('change', function() {
      const selectedCountry = countrySelect.value;

      subjectOptions.forEach(function(option) {
        const optionValue = option.value;
        if (!optionValue || !selectedCountry || option.getAttribute('data-countries').includes(selectedCountry)) {
          option.classList.remove('d-none');
        } else {
          option.classList.add('d-none');
        }
      });
    });


    subjectSelect.addEventListener('change', function() {
      const selectedSubject = subjectSelect.value;

      countryOptions.forEach(function(option) {
        const optionValue = option.value;
        if (!optionValue || !selectedSubject || option.getAttribute('data-subjects').includes(selectedSubject)) {
          option.classList.remove('d-none');
        } else {
          option.classList.add('d-none');
        }
      });
    });

  }

  // END Load Trips

  // JavaScript to handle the dropdown change event
  if(document.getElementById('dropdown-blog-filter')){
    document.getElementById('dropdown-blog-filter').addEventListener('change', function() {
      let selectedValue = this.value;
      if (selectedValue) {
        window.location.href = selectedValue;
      }
    });
  }

  // Lightbox Gallery

  let accGallery = document.querySelector(".accommodation-gallery");
  if (accGallery){
    baguetteBox.run(".accommodation-gallery");
  }

  let excGallery = document.querySelector(".excursions-gallery");
  if (excGallery) {
    baguetteBox.run('.excursions-gallery', {
      captions: createCaption
    });
  }

  function createCaption(element) {
    const title = element.getAttribute('data-caption-title');
    const description = element.getAttribute('data-caption-description');
    if (title || description) {
      let captionHTML = '';
      if (title) {
        captionHTML += '<h5>' + title + '</h5>';
      }
      if (description) {
        captionHTML += '<p>' + description + '</p>';
      }
      return captionHTML;
    }
    return '';
  }


  const videoTriggers = document.querySelectorAll('.video-trigger');
  const videoPopups = document.querySelectorAll('.video-popup');

  if (videoTriggers.length > 0 && videoPopups.length > 0) {
    const videoModal = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['video-modal'],
      onClose: function() {
        videoModal.setContent('');
      }
    });

    const extractVideoId = (url) => {
      const match = url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([^?]+)(\?.*)?/);
      return match ? `${match[1]}${match[2] || ''}` : url;
    };

    videoTriggers.forEach((videoTrigger, index) => {
      const videoPopup = videoPopups[index];
      if (videoPopup) {
        const videoLink = extractVideoId(videoPopup.dataset.video || '6GWgxa5XiEI?si=lRzxXeMHghNmoe6K');

        videoTrigger.addEventListener("click", function(e) {
          e.preventDefault();

          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', `https://www.youtube.com/embed/${videoLink}&autoplay=1`);
          iframe.setAttribute('width', '560');
          iframe.setAttribute('height', '315');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'true');

          videoModal.setContent(iframe);
          videoModal.open();
        });
      }
    });
  }





  function removeOverlay(){
    // Hide loader
    document.querySelector("body").classList.add('loaded');
    document.querySelector("body").classList.add('site-loaded');
    document.querySelector("html").classList.add('loaded');
    document.querySelector("html").classList.add('site-loaded');
  }

  function addOverlay(){
    // Show loader
    document.querySelector("body").classList.remove('loaded');
    document.querySelector("body").classList.remove('site-loaded');
    document.querySelector("html").classList.remove('loaded');
    document.querySelector("html").classList.remove('site-loaded');
  }

})